"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRandomAlphabeticalId = void 0;
var DEFAULT_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var getUnixTimestamp = function (date) {
    // eslint-disable-next-line no-bitwise
    return (date.getTime() / 1000) | 0;
};
var getRandomCharFromAlphabet = function (alphabet) {
    return alphabet.charAt(Math.floor(Math.random() * alphabet.length));
};
var generateRandomAlphabeticalId = function (idDesiredLength, alphabet) {
    if (idDesiredLength === void 0) { idDesiredLength = 20; }
    if (alphabet === void 0) { alphabet = DEFAULT_ALPHABET; }
    /**
     * Create n-long array and map it to random chars from given alphabet.
     * Then join individual chars as string
     */
    var randomString = Array.from({ length: idDesiredLength })
        .map(function () {
        return getRandomCharFromAlphabet(alphabet);
    })
        .join('');
    return "".concat(randomString).concat(getUnixTimestamp(new Date()));
};
exports.generateRandomAlphabeticalId = generateRandomAlphabeticalId;
